<template>
  <div class="author">
    <a-visibility hide :on="[$breakpoint.mobile]">
      <section class="author__content-desktop">
        <div class="author__logo-and-statistic">
          <author-logo :src="PhotoUrl" :alt-text="fullName" />
          <author-statistic
            :article-count="ArticleCount"
            :follower-count="FollowerCount"
            :is-follow-author-button-visible="isFollowAuthorButtonVisible"
            :is-followed="IsFollowed"
            :author-id="Id"
          />
        </div>
        <div class="author__info">
          <div class="author__content-top-section">
            <author-name-and-position
              :name="fullName"
              :job-title="Job"
              :company="Company"
            />

            <a-visibility show :on="buttonAndIconsVisibilityBreakpoints">
              <div class="author__become-an-author__wrapper">
                <become-an-author-button />
                <author-icons
                  :facebook-url="FacebookUrl"
                  :twitter-url="TwitterUrl"
                  :linked-in-url="LinkedInUrl"
                  :telegram-url="TelegramUrl"
                />
              </div>
            </a-visibility>
          </div>

          <author-about :about="Bio" />

          <a-visibility hide :on="buttonAndIconsVisibilityBreakpoints">
            <div class="author__become-an-author__wrapper">
              <author-icons
                :facebook-url="FacebookUrl"
                :twitter-url="TwitterUrl"
                :linked-in-url="LinkedInUrl"
                :telegram-url="TelegramUrl"
              />
              <become-an-author-button />
            </div>
          </a-visibility>
        </div>
      </section>
    </a-visibility>

    <a-visibility show :on="[$breakpoint.mobile]">
      <section>
        <author-name-and-position
          :name="fullName"
          :job-title="Job"
          :company="Company"
        />
        <author-logo :src="PhotoUrl" />
        <author-statistic
          :article-count="ArticleCount"
          :follower-count="FollowerCount"
          :is-follow-author-button-visible="isFollowAuthorButtonVisible"
          :author-id="Id"
          :is-followed="IsFollowed"
          @update:isFollowed="$emit('update:IsFollowed', $event)"
          @update:followerCount="$emit('update:FollowerCount', $event)"
        />
        <author-about :about="Bio" />
        <author-icons
          :facebook-url="FacebookUrl"
          :twitter-url="TwitterUrl"
          :linked-in-url="LinkedInUrl"
          :telegram-url="TelegramUrl"
        />
        <become-an-author-button />
      </section>
    </a-visibility>
  </div>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'
import AuthorLogo from './AuthorLogo'
import AuthorNameAndPosition from './AuthorNameAndPosition'
import AuthorAbout from './AuthorAbout'
import AuthorStatistic from './AuthorStatistic'
import BecomeAnAuthorButton from './BecomeAnAuthorButton'
import AuthorIcons from './AuthorIcons'
import { USER_TYPE, USER_STATUS } from 'enums/users'
import { mapGetters } from 'vuex'

export default {
  name: 'AuthorDetails',
  components: {
    AuthorLogo,
    AuthorNameAndPosition,
    AuthorAbout,
    AuthorStatistic,
    BecomeAnAuthorButton,
    AuthorIcons
  },
  props: {
    Id: propValidator([PROP_TYPES.STRING]),
    PhotoUrl: propValidator([PROP_TYPES.STRING], false),
    FirstName: propValidator([PROP_TYPES.STRING]),
    LastName: propValidator([PROP_TYPES.STRING]),
    /**
     * This field is missing in the Backend response.
     * ToDo: set required back to true as soon as
     * https://adraba.atlassian.net/browse/FMP-17356 is fixed.
     */
    Job: propValidator([PROP_TYPES.STRING], false),
    Role: propValidator([PROP_TYPES.STRING], true, null, role =>
      Object.values(USER_TYPE).includes(role)
    ),
    Status: propValidator([PROP_TYPES.STRING], true, null, status =>
      Object.values(USER_STATUS).includes(status)
    ),
    Company: propValidator([PROP_TYPES.STRING], false),
    Bio: propValidator([PROP_TYPES.STRING]),
    FacebookUrl: propValidator([PROP_TYPES.STRING], false),
    TwitterUrl: propValidator([PROP_TYPES.STRING], false),
    LinkedInUrl: propValidator([PROP_TYPES.STRING], false),
    TelegramUrl: propValidator([PROP_TYPES.STRING], false),
    Email: propValidator([PROP_TYPES.STRING]),
    IsFollowed: propValidator([PROP_TYPES.BOOLEAN]),
    ArticleCount: propValidator([PROP_TYPES.NUMBER], false),
    FollowerCount: propValidator([PROP_TYPES.NUMBER], false)
  },
  data() {
    return {
      buttonAndIconsVisibilityBreakpoints: [
        this.$breakpoint.desktopMd,
        this.$breakpoint.aboveDesktopXl
      ]
    }
  },
  computed: {
    ...mapGetters({
      userDetails: 'auth/userDetails'
    }),
    fullName() {
      return `${this.FirstName} ${this.LastName}`
    },
    isAuthorNotCurrentUser() {
      return (
        !this.userDetails.Id ||
        (this.userDetails.Id && this.Id && this.userDetails.Id !== this.Id)
      )
    },
    isFollowAuthorButtonVisible() {
      return (
        this.isAuthorNotCurrentUser &&
        this.Status === USER_STATUS.ACTIVE &&
        this.Role !== USER_TYPE.SUBSCRIBER
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.author {
  margin-bottom: 60px;

  @include mobile {
    margin-top: 0;
    margin-bottom: 20px;
  }

  .author__logo-and-statistic {
    margin-right: 60px;

    @include desktop-lg {
      margin-right: 40px;
    }

    @include desktop-sm {
      margin-right: 20px;
    }
  }

  .author__content-desktop {
    display: flex;
  }

  .author__content-top-section {
    display: flex;
    justify-content: space-between;
  }

  .author__info {
    flex-grow: 1;
  }

  .author__become-an-author__wrapper {
    width: 295px;

    @include desktop-lg {
      margin-top: 30px;
    }
  }
}
</style>
